'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useSettingsRoutes } from 'src/hooks/settings';

const AdminNavigation: React.FC = () => {
  const pathname = usePathname();
  const { adminRoutes: navItems } = useSettingsRoutes();

  return (
    <nav className="space-y-1">
      {navItems.map((item) => {
        const isActive = item.isActive(pathname);
        return (
          <Link
            key={item.id}
            href={item.path}
            className={`
              block px-3 py-2 text-sm font-medium rounded-md transition-colors duration-200
              ${
                isActive
                  ? ' text-sky-600'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
              }
            `}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
};

export default AdminNavigation;
